import React from 'react';
import Banner from './sections/Banner';
import Header from './sections/Header';
import Footer from './sections/Footer';
import { Container } from 'reactstrap';
import { string } from 'prop-types';
import { removeHyphensAndCapitalize } from '../helpers';
import Form from '../containers/Form';
import { CONTACT_US } from '../utils/constants';

const ContactUs = ({ url }) => (
  <>
    <Banner pageType={CONTACT_US} title={removeHyphensAndCapitalize(url)}>
      <Container>
        <Header />
      </Container>
    </Banner>

    <Form />

    <Footer />
  </>
)

ContactUs.propTypes = {
  url: string,
}

ContactUs.defaultProps = {
  url: '',
}

export default ContactUs